import React from 'react';
import '../styles/features.css';

const Features = () => {
    return (
        <section id="features" className="features-section">
            <div className="section-header">
                <h2>How Our <span className="highlight">AI Dream Team</span> Works</h2>
                <p>Seamless automation that transforms your digital marketing</p>
            </div>

            <div className="features-container">
                <div className="feature-step">
                    <div className="step-number">01</div>
                    <div className="step-content">
                        <h3>Data Collection & Analysis</h3>
                        <p>Our AI assistants gather and analyze data from your industry, competitors, and target
                            audience to establish a strategic foundation.</p>
                    </div>
                    <div className="step-image">
                        <img src="/assets/images/data-analysis.jpg" alt="Data Analysis"/>
                    </div>
                </div>

                <div className="feature-step reverse">
                    <div className="step-number">02</div>
                    <div className="step-content">
                        <h3>Strategy Development</h3>
                        <p>Based on collected insights, our AI creates a customized marketing strategy aligned with your
                            business goals and target audience.</p>
                    </div>
                    <div className="step-image">
                        <img src="/assets/images/strategy.jpg" alt="Strategy Development"/>
                    </div>
                </div>

                <div className="feature-step">
                    <div className="step-number">03</div>
                    <div className="step-content">
                        <h3>Content Creation & Distribution</h3>
                        <p>AI assistants generate and distribute engaging content across all relevant channels,
                            maintaining brand consistency.</p>
                    </div>
                    <div className="step-image">
                        <img src="/assets/images/content-creation.png" alt="Content Creation"/>
                    </div>
                </div>

                <div className="feature-step reverse">
                    <div className="step-number">04</div>
                    <div className="step-content">
                        <h3>Human-Guided AI</h3>
                        <p>Our assistants operate with human oversight, guaranteeing full compliance with ethical
                            and regulatory AI standards. Trust in every step!</p>
                    </div>
                    <div className="step-image">
                        <img src="/assets/images/oversight.jpg" alt="Oversight"/>
                    </div>
                </div>

                <div className="feature-step">
                    <div className="step-number">05</div>
                    <div className="step-content">
                        <h3>Continuous Optimization</h3>
                        <p>Our platform constantly learns from performance data, with our assistants making real-time adjustments to maximize
                            campaign effectiveness.</p>
                    </div>
                    <div className="step-image">
                        <img src="/assets/images/optimization.png" alt="Optimization"/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Features;